import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/694559813f8dad00147217ca/arbitrage_elite/src/app/homepage-french/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/694559813f8dad00147217ca/arbitrage_elite/src/app/homepage-french/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/694559813f8dad00147217ca/arbitrage_elite/src/components/common/Header.tsx");
